import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaExclamationCircle } from "react-icons/fa";

/**
 * Componente que renderiza um overlay com um tooltip.
 *
 * @component
 * @param {Object} props - Propriedades do componente.
 * @param {string|number|function} props.contentToDisplay - Conteúdo a ser exibido no tooltip. Pode ser uma string, um número ou uma função que retorna um elemento React.
 * @param {React.Component} [props.Component] - Componente opcional a ser renderizado no lugar do ícone padrão. Se não for fornecido, um ícone de aviso será exibido.
 *
 * @returns {JSX.Element} O componente `GenericOverlay`.
 *
 * @example
 * // Exemplo de uso do GenericOverlay
 * const MyComponent = () => {
 *     const tooltipContent = "Este é um tooltip informativo.";
 *     
 *     return (
 *         <GenericOverlay contentToDisplay={tooltipContent} />
 *     );
 * };
 */
const GenericOverlay = ({ contentToDisplay, Component, disabled, delay = {show: 0, hide: 0}}) => {
    const contentRenderer = () => {
        const contentType = typeof contentToDisplay;
        switch (contentType) {
            case !contentToDisplay:
                console.error("Overlay content not available");
                break;
            case "function":
                return contentToDisplay();
            case "number":
                return contentToDisplay;
            case "string":
                return contentToDisplay;
            default:
                console.error("Type of overlay content is not valid, please pass a valid content (string or function)");
        }
    };

    const componentRender = () => {
        if (Component) {
            return <Component />;
        } else {
            return <FaExclamationCircle size={20} />;
        }
    };

    return (
        <OverlayTrigger
        delay={delay}
       
            overlay={
                <Tooltip className="text-secondary" hidden={disabled} id="tooltip-info">
                    {contentRenderer()}
                </Tooltip>
            }
        >
            <span
                className="ml-8 "
                style={{ cursor: "pointer" }}
            >
                {componentRender()}
            </span>
        </OverlayTrigger>
    );
};

export default GenericOverlay;
